'use strict';

var updateProductInfoHeight = function updateProductInfoHeight() {
  var h = $('.product__image').outerHeight();
  $('.product__info').css('minHeight', h);
};

var handleStickyFooter = function handleStickyFooter() {
  $(window).resize(function (event) {
    var height = $('.footer').outerHeight();
    $('body').css({
      'paddingBottom': height,
      'position': 'relative',
      'minHeight': $(window).outerHeight()
    });
    $('.footer').css({
      'position': 'absolute',
      'bottom': 0,
      'left': 0,
      'right': 0
    });
  }).resize();
};

var handleReturnsSection = function handleReturnsSection() {
  if (window.TITLE == "terms-and-conditions") {
    console.log('handleReturnsSection 2');
    $('.main-content h4').each(function (index, el) {
      var text = $(el).text().trim().toLowerCase();
      if (text == 'product returns') {
        $(el).attr('id', 'returns').addClass('is-highlight');
        $(el).next().addClass('is-highlight');
        window.location.href = window.location.pathname + '#returns';
      }
    });
  }
};

var qty = function qty(operation, element) {
  var id = event.target.dataset.id;
  var _input = document.querySelector('#qty-id-' + id);
  console.log(element);
  if (_input.value == 1 && operation == 'decr') return false;
  switch (operation) {
    case 'incr':
      _input.value++;
      break;
    case 'decr':
      _input.value--;
      break;
    default:
      // statements_def
      break;
  }
  if (element == 'cart') {
    var url = "/cart/change?line={{line}}&quantity={{qty}}";
    var _updateLink = document.querySelector('#qty-link-' + id);
    var line = _updateLink.dataset.line;
    url = url.replace('{{line}}', line).replace('{{qty}}', _input.value);
    _updateLink.href = url;
  }
  if (element == 'product') {
    var _cartBtn = document.querySelector('.js-add-to-cart');
    console.log(_cartBtn.dataset);
    switch (operation) {
      case 'incr':
        _cartBtn.dataset.quantity++;
        break;
      case 'decr':
        _cartBtn.dataset.quantity--;
        break;
      default:
        // statements_def
        break;
    }
  }
};

$(document).ready(function () {

  if ($('.product__image').length && $('.product__info').length) {
    updateProductInfoHeight();
    $('window').resize(updateProductInfoHeight);
  }

  $('[data-accordion-button]').click(function (event) {
    $(this).toggleClass('is-open');
    $(this).siblings('[data-accordion]').slideToggle();
  });

  if ($('.js-related-slider').length) {
    $('.js-related-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  $('.widget-social__search').click(function (event) {
    event.preventDefault();
    var parent = $(this).closest('.js-search-bar');
    parent.find('.search-bar').toggleClass('is-open');
    if (parent.find('.search-bar').hasClass('is-open')) {
      parent.find('.input-wrapper input').focus();
    }
  });

  handleReturnsSection();
  handleStickyFooter();

  $('.js-menu-toggle').click(function (event) {
    $('body').toggleClass('header-open');
  });

  $('.js-add-to-cart').click(function (event) {
    event.preventDefault();
    var id = $(this).attr('data-id');
    var quantity = $(this).attr('data-quantity');
    CartJS.addItem(id, quantity, null, {
      success: function success(data) {
        $('.purchase-dialog__title').text(data.product_title);
        $('.purchase-dialog__count').text(data.quantity);
        $('.purchase-dialog__image').attr('src', data.image);
        $('.js-purchase-dialog.success, .js-purchase-dialog.overlay').addClass('is-open');
        $('.js-purchase-dialog.error').removeClass('is-open');
        // var tHandle = window.setTimeout(function() {
        //   $('.js-purchase-dialog.success').removeClass('is-open');
        // }, 5000)
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        var json = jqXHR.responseJSON;
        var message = json.message + '<br><br>' + json.description;
        if (json.description == "Cannot find variant") {
          message = "Product is out of stock";
        }
        $('.js-purchase-dialog.success').removeClass('is-open');
        $('.js-purchase-dialog.error, .js-purchase-dialog.overlay').addClass('is-open');
        $('.purchase-dialog__content.error').html(message);
        // setTimeout(function() {
        // $('.js-purchase-dialog.error').removeClass('is-open');
        // }, 5000)
      }
    });
  });
  $(document).on('cart.requestComplete', function (event, cart) {
    $('.js-cart-total-price').html(cart.total_price);
  });
  $('.js-purchase-dialog .close, .js-purchase-dialog.overlay').click(function (event) {
    $('.js-purchase-dialog').removeClass('is-open');
  });

  $('.compare-products__btn').click(function () {
    $('.compare-products').toggleClass('opened');
  });
});